import React, { useEffect } from "react";
import { Table  } from 'antd';
import { connect } from "react-redux";
import { 
    getClientUserList, doClientUserDelete
} from "../../../../../redux/client/clientState";
import { handleTableChange } from "utils";
import Card from "components/card";

import CrudOption from "components/dropdown/crudoption";
import PopupButton from "components/button/PopupButton";
import ClientUserForm from "./ClientUserForm";


const ClientUserTable = ({ recordList, pagination, doSearch, filters, doDelete, clientId }) => {

    const columns = [
		{
	        title: `Name`,
	        dataIndex: 'user_full_name',
	        key: 'user_full_name',
	        width: '20%',
	        render:(user_full_name) => <span>{user_full_name}</span> 
	    },
        {
	        title: `Role`,
	        dataIndex: 'clu_job_title',
	        key: 'clu_job_title',
	        width: '15%',
	        render:(clu_job_title) => <span>{clu_job_title}</span> 
	    },
        {
	        title: `Email`,
	        dataIndex: 'user',
	        key: 'user',
	        width: '20%',
	        render:(user) => <span>{user?.email}</span> 
	    },
        {
	        title: `Managed Teams`,
	        dataIndex: 'team_name',
	        key: 'team_name',
	        width: '30%',
	        render:(team_name) => <span>{team_name}</span> 
	    },
        {
	        title: <PopupButton id="add_client_user" title="Add Client User" label="Add" btnClass="btn-small">
						<ClientUserForm recordId={0} mode="edit" clientId={clientId} />
					</PopupButton>,
	        dataIndex: 'clu_id',
	        key: 'clu_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
                                    baseRoute={`/console/clients/${clientId}/client-users`} 
                                    recordId={record?.clu_id} 
                                    allowEdit={false}
                                    deleteHandler={() => doDelete({
                                        clu_client_id: record?.clu_client_id,
                                        clu_id: record?.clu_id,
                                    })} 
                                />
	    },
    ]   
	
    
    useEffect(() => {
        if (clientId) {
            doSearch({paginate: pagination.per_page, clientId});
        } 
    }, [doSearch, clientId, pagination.per_page]);

    return (   
        <Card extra={"w-full h-full"}>
            <div className="h-full overflow-x-scroll xl:overflow-x-hidden">
                <Table
                    dataSource={recordList} 
                    columns={columns} 
                    rowKey={(record) => record.clu_id}
                    pagination={{...pagination, 
                        showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
                    onChange={handleTableChange(doSearch, filters)}                  	
                />
            </div>
        </Card>
    );
};

const mapStateToProps = (state) => ({
    recordList: state.client.clientUserList?.items,
    pagination: state.client.clientUserList?.pagination,
    filters: state.client.clientUserList?.filters,
    requesting: state.client.clientUserList?.requesting,
    error: state.client.clientUserList?.error,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getClientUserList(filters)),
    doDelete: (id) => dispatch(doClientUserDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientUserTable);
